import React, { Component, PropTypes } from "react";
import { Link } from "react-router";

class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="max_width_nobg">
          <div className="logo">
            <Link to="/">
              <img src="/assets/img/logo.png" alt="logo" />
            </Link>
          </div>
          <div className="footer_container_info">
            <p className="copyright">© Medcafe 2018. All rights reserved.</p>
            <div className="footer_links">
              <ul>
                <li>
                  <Link to="/cookie_policy">Cookie Policy</Link>
                </li>
                <li>
                  <Link to="/terms_of_service">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/privacy_policy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/containers/Footer/Footer.js
 **/